'use client'

import {Button, Select, SelectOptionType, SlideshowNative, SmallText} from '@local/ui/components'
import {CSSProperties, useRef, useState} from 'react'

export interface ProductScheduleContentProps {
	days: SelectOptionType[]
	schedules: Array<Array<{
		activity: string
		timePeriod: string
	}>>
	variant?: 'dark' | 'light'
}

export const ProductScheduleContent = ({schedules, days, variant = 'dark'}: ProductScheduleContentProps) => {
	const slideshowRef = useRef<HTMLDivElement>(null)
	const [activeIndex, setActiveIndex] = useState<number>(0)

	const handleSelect = (e) => {
		const index = parseInt(e.target.value)
		handleScrollTo(index)
	}

	const handleScrollTo = (index:number) => {
		setActiveIndex(index)
		if (slideshowRef.current) {
			slideshowRef.current.scrollToIndex(index)
		}
	}

	const handleSlideshowChange = (index) => {
		setActiveIndex(index)
	}

	return (
		<div>
			<Select
				theme={variant === 'dark' ? 'dark-grey' : 'light'}
				name='days'
				id='product-schedule-days-select'
				options={days}
				value={activeIndex}
				defaultValue={undefined}
				onChange={handleSelect}
				containerClassName='w-full border-0 lg:hidden'
				className='text-12' />

			<ul
				className='lg-max:hidden span-w-5 grid grid-cols-[repeat(var(--grid-count),1fr)] gap-8'
				style={{'--grid-count': Math.min(days.length, 7)} as CSSProperties}>
				{days.map((item, index) => (
					<li key={`button-${item.value}`} className=''>
						<Button
							small
							active={index === activeIndex}
							variant={variant === 'dark' ? 'primary-transparent' : 'secondary-transparent'}
							className='px-0 w-full border-grey-2'
							onClick={() => handleScrollTo(index)}>
							{item.label}
						</Button>
					</li>
				))}
			</ul>

			{!!schedules.length && (
				<SlideshowNative
					ref={slideshowRef}
					threshold={0.8}
					disableObserverOnMobile
					onChange={handleSlideshowChange}
					containerClassName='w-full lg:span-w-5 overflow-clip'
					className='pt-40 w-full lg:pointer-events-none'>
					{schedules.map((day, index) => (
						<ul
							className='span-w-12 lg:span-w-5 gutter-mx-1'
							key={`item-${index}`}>
							{day.map((item, innerIndex) => (
								<li
									key={`innerItem-${innerIndex}`}
									className='flex flex-row items-center justify-between gutter-gap-1 py-12 border-t border-grey-2 -gutter-mx-1 gutter-px-1'>
									<h3 className='text-11 leading-none uppercase tracking-wide'>{item.activity}</h3>
									<SmallText textColor={variant === 'dark' ? 'grey-1' : 'black'} className='shrink-0'>{item.timePeriod}</SmallText>
								</li>
							))}
						</ul>
					))}
				</SlideshowNative>
			)}
		</div>
	)
}
